import React, { useState, useEffect } from 'react'
import NavbarComponent from '../components/navbar'
import { Form, Button } from 'react-bootstrap'
import UserProfile from '../user'
import csvDownload from 'json-to-csv-export'
import Footer from '../components/footer'
import { getLabelNames, getLabels } from '../api'

import './styles/datasets.css'

const DatasetsPage = () => {
    const [dataset, setDataset] = useState([])
    const [existingLabels, setExistingLables] = useState([])
    const [query, setQuery] = useState('')
    const [searched, setSearched] = useState('')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getLabelNames().then(setExistingLables).catch(error => console.log(error))
    }, [])

    const searchExistingLabels = async (label) => {
        label = String(label).trim()
        if (!label) return
        if (UserProfile.getName() === "") {
            window.alert("Please sign up on the home page first.")
            return
        }
        setQuery(label)
        setLoading(true)
        try {
            setDataset(await getLabels(label))
            setSearched(label)
        } catch (error) {
            window.alert(`Could not load the dataset: ${error.message}`)
        } finally {
            setLoading(false)
        }
    }

    const getData = async (e) => {
        e.preventDefault()
        await searchExistingLabels(query)
    }

    const downloadCsv = () => {
        csvDownload(dataset)
    }

    return (
        <>
            <NavbarComponent />
            <main className="ocn-wrap">
                <div className="ocn-pagehead">
                    <p className="ocn-eyebrow">Datasets</p>
                    <h1>Browse and download labels</h1>
                    <p>Search by label to see every commit rated on that attribute, then download the results as a CSV.</p>
                </div>

                <div className="ocn-card" style={{ marginBottom: '1.5rem' }}>
                    <Form onSubmit={getData} className="ocn-search">
                        <Form.Control
                            id="label_search"
                            aria-label="Search by label"
                            placeholder="Search by label, e.g. novelty"
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                        />
                        <Button type="submit" disabled={loading}>{loading ? 'Searching…' : 'Search'}</Button>
                    </Form>
                    <div style={{ marginTop: '1rem' }}>
                        <p className="ocn-eyebrow">Available labels</p>
                        <div className="ocn-chips">
                            {existingLabels.length === 0 && <span className="ocn-empty">Loading labels…</span>}
                            {existingLabels.map(label => (
                                <button
                                    type="button"
                                    key={label}
                                    className={`ocn-chip${searched === label ? ' selected' : ''}`}
                                    onClick={() => searchExistingLabels(label)}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {searched === '' ? (
                    <p className="ocn-empty">Choose a label above to see the labelled commits.</p>
                ) : (
                    <>
                        <div className="ocn-table-wrap">
                            <table className="ocn-table">
                                <thead>
                                    <tr>
                                        <th>Commit</th>
                                        <th>Type of commit</th>
                                        <th>Label</th>
                                        <th>Score</th>
                                        <th>Confidence</th>
                                        <th>Labelled by</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataset.slice(0, 10).map((data, i) => (
                                        <tr key={i}>
                                            <td><a href={data["commit link"]} target="_blank" rel="noopener noreferrer">{String(data["commit link"]).replace('https://github.com/', '').replace('/commit/', ' @ ').replace(/(@ [0-9a-f]{7})[0-9a-f]*$/i, '$1')}</a></td>
                                            <td>{data["type of commit"]}</td>
                                            <td>{data["label"]}</td>
                                            <td className="num">{data["score"]}</td>
                                            <td className="num">{data["confidence"]}</td>
                                            <td>{data["github profile"]}</td>
                                        </tr>
                                    ))}
                                    {dataset.length === 0 && (
                                        <tr><td colSpan={6} className="ocn-empty">No commits have been labelled “{searched}” yet.</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="ocn-results">
                            <span className="ocn-muted">
                                {dataset.length > 10
                                    ? `Showing 10 of ${dataset.length} results. Download the CSV for all of them.`
                                    : `${dataset.length} result${dataset.length === 1 ? '' : 's'}`}
                            </span>
                            <Button onClick={downloadCsv} disabled={dataset.length === 0}>Download CSV</Button>
                        </div>
                    </>
                )}
            </main>
            <Footer />
        </>
    )
}

export default DatasetsPage
